import React, { useContext, useState, useEffect, createContext, useRef } from 'react';
import { AppContext } from '../App';
import { WEB_SOCKET_URL, callGameServerApi, getInlineLoader, isAlphanumeric, resolveOrientation } from '../Helpers';
import { IoEnterOutline } from 'react-icons/io5';
import TopBar from '../components/TopBar';
import SignIn from '../views/SignIn';
import TypingBox2 from '../components/TypingBox2';
import OneMessage from '../ones/OneMessage';
import { generateRandomString } from '../Helpers';

export const ChatContext = createContext(null);

export default function View(props) {
  const appContext = useContext(AppContext);
  const [ ready, setReady ] = useState(false);
  const [ loading, setLoading ] = useState(false);
  const [ chatData, setChatData ] = useState(null);
  const [ replyTo, setReplyTo ] = useState(null);

  const messageSenderUrl = 'send-community-message';

  const webSocketRef = useRef(null)
  const [ webSocketConnected, setWebSocketConnected ] = useState(2); //0 = not, 1=conn, 2= start
  const [ webSocketReconnectTimer, setWebSocketReconnectTimer ] = useState(null);
  const wsRandomId = generateRandomString();
  

  async function setupWebSocket() {
    //subscribe for chat data updates
    const user = await appContext.getLocalUser();
    webSocketRef.current = new WebSocket(WEB_SOCKET_URL);
    webSocketRef.current.addEventListener('open', async () => {
      //send subscription message
      // using delay hack
      setTimeout(async () => {
        if(webSocketRef.current.readyState === WebSocket.OPEN) {
          webSocketRef.current.send(JSON.stringify({
            type: 'subscribe-for-community-chat-data',
            userId: user.userId,
            userToken: user.userToken,
            sourceId: 'communityChat'+wsRandomId,
          }))
        }
      }, 3000);
      setWebSocketConnected(1);
    })

    webSocketRef.current.addEventListener('close', (e) => {
      if(!e.wasClean) {
        setWebSocketConnected(0);
        //try to reconnect after 5 seconds
        setWebSocketReconnectTimer((prevTimer) => {
          if(prevTimer) {
            clearInterval(prevTimer);
          }

          let timer = setInterval(() => {
            setupWebSocket();
          }, 5000);

          return timer;
        })
      }
    })

    webSocketRef.current.addEventListener('message', (e) => {
      const response = JSON.parse(e.data);
      console.log(response);
      setChatData(response.chatData);
    })

    
  }

  async function closeWebSocket() {
    //send unsubscribe req 
    const user = await appContext.getLocalUser();
    if(webSocketRef.current && webSocketRef.current.readyState === WebSocket.OPEN) {
      webSocketRef.current.send(JSON.stringify({
        type: 'unsubscribe-for-community-chat-data',
        userId: user.userId,
        userToken: user.userToken,
        sourceId: 'communityChat'+wsRandomId,
      }))
    }

    //then close connection
    if(webSocketRef.current) {
      webSocketRef.current.close();
    }

    //clear  reconnect timer
    if(webSocketReconnectTimer) {
      clearInterval(webSocketReconnectTimer);
    }
  }
  
  const getChatData = () => {
    return new Promise(async resolve => {
      await callGameServerApi('get-community-messages', { }).then(response => {
        if(response.status === 1) {
          resolve(response.data)
        } else {
          //could not get chat data
          resolve(null);
        }
        
      })
    })
  }

  const scrollToMessage = (messageId) => {
    document.getElementById('_message_'+messageId).scrollIntoView({
      behavior: "smooth"
    });

    document.getElementById('_message_'+messageId).style.background = "#7a7771";
    setTimeout(() => {
      document.getElementById('_message_'+messageId).style.background = "inherit";
    }, 1000)
  }

  const init = async () => {
    await getChatData().then(data => {
      setReady(true);
      setupWebSocket();
      if(data) {
        setChatData(data);
        
      }
    })
  }

  
  useEffect(() => {
  
    init();

    return () => {
      closeWebSocket();
    }
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
    }
  }, [ ready ]);

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [ loading ]);

  const chatContext = {
    getChatData,
    setChatData,
    chatData,
    replyTo,
    setReplyTo,
    scrollToMessage,
    messageSenderUrl,
  }

  if(ready) {
    if(appContext.auth) {
      return (
        <ChatContext.Provider value={chatContext}>
          <div className='CChatsHolder container'>
            {
              (chatData && chatData.messages && JSON.parse(chatData.messages).length > 0) ?
              JSON.parse(chatData.messages).map((item, i) => {
                return <OneMessage data={item} key={i} id={i}/>
              })
              :
              <small className='text-muted'>No messages were found</small>

            }
          </div>
          <TypingBox2/>
        </ChatContext.Provider>
      )
    } else {
      //return login screen
      return <SignIn/>
    }
  } else {
    return (
      <div className="container support-loading">
        {getInlineLoader()}
      </div>
    )
  }
}
